// mega-menu.js — hover on desktop, tap-to-toggle + slide-in on mobile
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.tbx-has-panel');
  const hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  let closeTimer = null;

  function closeAll(except) {
    items.forEach(function (li) {
      if (li !== except) li.classList.remove('tbx-open');
    });
  }

  items.forEach(function (li) {
    const trigger = li.querySelector(':scope > .tbx-nav-link');

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = li.classList.contains('tbx-open');
      closeAll(li);
      li.classList.toggle('tbx-open', !isOpen);
    });

    if (hasHover) {
      li.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeAll(li);
        li.classList.add('tbx-open');
      });
      li.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          li.classList.remove('tbx-open');
        }, 120);
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (![...items].some(function (li) { return li.contains(e.target); })) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // Mobile off-canvas nav
  const hamburger = document.getElementById('tbxHamburgerBtn');
  const mainNav = document.getElementById('tbxMainNav');
  const overlay = document.getElementById('tbxNavOverlay');

  if (hamburger && mainNav && overlay) {
    hamburger.addEventListener('click', function () {
      mainNav.classList.add('tbx-mobile-open');
      overlay.classList.add('tbx-show');
    });
    overlay.addEventListener('click', function () {
      mainNav.classList.remove('tbx-mobile-open');
      overlay.classList.remove('tbx-show');
      closeAll();
    });
  }
});